module.exports = __webpack_public_path__ + "static/media/stofferingen-07.7766a629.jpg";